import React from 'react'
import { UserActionHistoryTableProps } from './UserActionHistoryTable.types'
import styles from './UserActionHistoryTable.module.scss'
import cl from 'classnames'
import { ActionHistoryTable } from 'components'

const UserActionHistoryTableComponent = (props: UserActionHistoryTableProps) => {
  const {
    userId
  } = props

  return (
    <div className={cl(styles.container)}>
      <ActionHistoryTable
        userId={userId}
        hidePaginationInfo
        paginationProps={{ size: 5 }}
        tableContainerProps={{
          noBoxShadow: true
        }}
        tableBodyLineProps={{
          // className: styles.tableBody,
          containerProps: {
            className: styles.tableBody
          }
        }}
        viewAllButtonContainerProps={{
          className: styles.tableBody
        }}
        viewAllButtonProps={{
          onClick: () => console.log('CLICK'),
          disabled: true
        }}
        isDashboardVersion={true}
      />
    </div>
  )
}

const UserActionHistoryTable = UserActionHistoryTableComponent
export { UserActionHistoryTable }
